import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ControlValueAccessor, NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormFieldModule } from '@angular/material/form-field';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-address-form',
    templateUrl: './custom-address-form.component.html',
    styleUrls: ['./custom-address-form.component.scss'],
    providers: [
        {
            provide: MatFormFieldControl,
            useExisting: CustomAddressFormComponent
        }
    ],
    standalone: false
})
export class CustomAddressFormComponent implements OnInit, MatFormFieldControl<any>, ControlValueAccessor {

    @Input() showState = true;
    @Input() showCountry = true;
    addressForm: FormGroup;

    stateChanges = new Subject<void>();
    focused = false;
    controlType = 'app-address';
    id = `app-address-${CustomAddressFormComponent.nextId++}`;
    describedBy = '';

    onChange: any = () => {};
    onTouched: any = () => {};
    static nextId: number = 0;

    constructor(
        private formBuilder: FormBuilder,
        @Optional() @Self() public ngControl: NgControl,
    ) {
        if (this.ngControl != null) {
            this.ngControl.valueAccessor = this;
        }
    }
    ngOnInit(): void {
        this.addressForm = this.formBuilder.group({
            address1: ['2nd cross', Validators.required],
            address2: ['Church Street', Validators.required],
            city: ['Bangalore', Validators.required],
            taluk: ['East', Validators.required],
            district: ['Bangalore', Validators.required],
            state: ['Karanataka'],
            country: ['India'],
            pinCode: ['560001'],
        });

        this.addressForm.valueChanges.subscribe(value => {
            this.onChange(value);
            this.onTouched();
            console.log(value);
        });
    }
    get value(): any {
        return this.addressForm.value;
    }
    set value(value: any) {
        this.onChange(value);
        this.onTouched();
        this.stateChanges.next();
    }

    placeholder: string;
    empty: boolean;
    shouldLabelFloat: boolean;
    required: boolean;
    disabled: boolean;
    errorState: boolean;
    autofilled?: boolean;
    userAriaDescribedBy?: string;

    getAddressData(): object {
        const formValue = this.addressForm.value;
        const addressData: any = {};

        // Exclude empty values and optional fields if they are disabled
        Object.keys(formValue).forEach(key => {
          if (formValue[key] !== '' && formValue[key] !== null) {
            if (key === 'country' && !this.showCountry) {
              return; // Skip if country field is disabled
            }

            if (key === 'pinCode' && !this.showState) {
              return; // Skip if pin code field is disabled
            }

            addressData[key] = formValue[key];
          }
        });

        return addressData;
    }

    setDescribedByIds(ids: string[]): void {
        this.describedBy = ids.join(' ');
    }

    onContainerClick(event: MouseEvent): void {
        // Implement if needed
    }

    writeValue(value: any): void {
        if (value) {
          this.addressForm.setValue(value);
        }
    }

    registerOnChange(fn: any): void {
        console.log(fn);
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        if (isDisabled) {
          this.addressForm.disable();
        } else {
          this.addressForm.enable();
        }

        this.stateChanges.next();
    }

}
